export default __webpack_public_path__ + "static/media/14_gaming_desktop.d9c16ffb.png";